import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ListResult } from "../api/core/list-result";
import { TaskList } from "../api/task/task-list";
import { BACKEND_URL } from "../app.config";

@Injectable()
export class TaskListService {
  constructor(
    private readonly http: HttpClient,
    @Inject(BACKEND_URL) private readonly baseUrl: string
  ) { }

  getList(sorting: string = '', skipCount: number = 0, maxResultCount: number = 100): Observable<ListResult<TaskList>> {
    return this.http.get<ListResult<TaskList>>(this.baseUrl + '/api/app/task-list', {
      params: {
        sorting,
        skipCount: skipCount.toString(),
        maxResultCount: maxResultCount.toString()
      }
    });
  }
}
